import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { spinSettings } from 'settings/custom/reels'
import { delay, delayCallBack } from 'utils/Delay'

export default class CascadeEntity extends PIXI.Container{
  constructor() {
    super()
    this.reels = []
    this.overReels = []

    signal.on('CascadeEntity:START', this.start.bind(this))
    signal.on('CascadeEntity:REFRESH', (val) => this.refresh(val))
    signal.on('ACTION:CASCADE-WIN', this.cascadeWin.bind(this))
    signal.on('ACTION:CASCADE-Drop', this.dropStart.bind(this))
    signal.once('STATE:OUT:INIT', this.addOverReels.bind(this))
  }

  addOverReels(){
    this.overReels.forEach((container, index) => {
      this.reels[index].setOverSymbolContainer(container)
    })
  }

  refresh(isFs) {
    this.reels.forEach((reel) => {
      reel.refresh(isFs)
    })
  }

  start() {
    signal.dispatch('REELS-START')
    const time = StoreageService.get('turbo') ? spinSettings.minTurboTime : spinSettings.minSpinTime
    const minSpinTime = delay(time)
    const readyToStop = signal.promise('ACTION:REEL-SPIN')
    Promise.all([readyToStop, minSpinTime]).then(stop)
    Promise.all(this.reels.map((reel) => reel.spin())).then(() => signal.dispatch('REELS-STOP'))
  }

  cascadeWin(){
    const cascadeModel = game.models.CascadeModel
    const position = cascadeModel.get().positions
    Promise.all(this.reels.map((reel, i) => reel.showCascadeWin(this.checkIDPositionCascade(position[cascadeModel.get().currentCascade], i), cascadeModel.get().currentCascade))).then(() => signal.dispatch('CASCADE-WIN-ANIM:DONE'))
  }

  dropStart(){
    signal.dispatch('CASCADE-DROP-ANIM:START')
    const cascadeModel = game.models.CascadeModel
    const position = cascadeModel.get().positions
    Promise.all(this.reels.map((reel, i) => reel.showCascadeDrop(this.checkIDPositionCascade(position[cascadeModel.get().currentCascade], i), cascadeModel.get().currentCascade))).then(() => {
      cascadeModel.get().all--
      if(cascadeModel.get().all > -1){
        cascadeModel.get().currentCascade++
      }
      signal.dispatch('CASCADE-DROP-ANIM:DONE')
    } )
  }

  checkIDPositionCascade(positions, i) {
    const sortArr = []
    if(positions !== undefined) {
      positions.forEach((pos) => {
        if(pos[0] === i){
          sortArr.push(pos[1])
        }
      })
    }
    return sortArr
  }

  stop() {
    for (let i = 0; i < this.reels.length; i++) {
      delayCallBack(spinSettings.delayStop, () => {
        this.reels[i].stop()
      }).then(() => {

      })
    }
  }

  register = (type, object) => {
    if (type === 'CascadeReel') {
      this.reels.push(object)
    }

    if (type === 'OverSymbolReel') {
      this.overReels.push(object)
    }
  }
}
